module.exports = __webpack_public_path__ + "img/followup-question.c84fdbd7.svg";